module.exports = " <div class=hello _v-76e33e1a=\"\"> <h1 _v-76e33e1a=\"\">{{ msg }}</h1> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-76e33e1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
 ** module id = 15
 ** module chunks = 1
 **/